import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const applyTheme = (isDark) => {
    const root = document.documentElement;
    
    if (isDark) {
      root.classList.add('dark');
      setIsDarkMode(true);
    } else {
      root.classList.remove('dark');
      setIsDarkMode(false);
    }
  };

  const initializeTheme = useCallback(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    const isDark = savedTheme === 'dark';
    applyTheme(isDark);
  }, []);

  const toggleTheme = () => {
    const newIsDark = !isDarkMode;
    localStorage.setItem('theme', newIsDark ? 'dark' : 'light');
    applyTheme(newIsDark);
  };

  const getThemeIcon = () => {
    return isDarkMode ? 'sun' : 'moon';
  };

  const getThemeTooltip = () => {
    return isDarkMode ? 'Switch to light mode' : 'Switch to dark mode';
  };

  useEffect(() => {
    initializeTheme();
  }, [initializeTheme]);

  const value = {
    isDarkMode,
    toggleTheme,
    getThemeIcon,
    getThemeTooltip
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
